{
    "Profile_Residents.residents": "Residents",
    "Profile_Residents.resident": "Resident {number}"
}
